import 'antd/dist/antd.css';
import '@/_app.less'
import api from '@/utils/api';
import { API_URL } from '../constants';
import { useEffect } from 'react';
import { Row, Col, Typography } from 'antd';
import styled from 'styled-components';
import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import { Provider } from "react-redux";
import { store, wrapper } from '../configureStore';
import WPSettingsPage from './settings';
import { WPModelInlineSearch } from './inline_search';
import { Appointment } from './appointment';
import '@/wordpress/index.css'
import '@/wordpress/theme_flatsome_corrections.css'
const { Title } = Typography

const WPAppointment = ({ settings, redirect_url }) => {
  return <Provider store={wrapper}>
    <Row type="flex">
      <Col span={24}>
        <Appointment settings={settings} redirect_url={redirect_url} />
      </Col>
    </Row>
  </Provider>
}

export { WPSettingsPage, React, ReactDOM, Provider, WPAppointment, WPModelInlineSearch }
